import { render, staticRenderFns } from "./SecondChanceDetail.vue?vue&type=template&id=78789101&scoped=true"
import script from "./SecondChanceDetail.vue?vue&type=script&lang=js"
export * from "./SecondChanceDetail.vue?vue&type=script&lang=js"
import style0 from "./SecondChanceDetail.vue?vue&type=style&index=0&id=78789101&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78789101",
  null
  
)

export default component.exports